export default "__VITE_ASSET__BvnSZY5Y__"